<template>
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.16667 8.26953L1.5 15.7695L16.5 8.26953L1.5 0.769531L3.16667 8.26953ZM3.16667 8.26953L9.83333 8.26953"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke="strokeColor"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    fillColor: {
      type: String,
      required: false,
      default: '#111827',
    },
    strokeColor: {
      type: String,
      required: false,
      default: '#fff',
    },
  },
  setup({}, { emit }) {},
})
</script>

<style scoped></style>
